export const SeparatorHorizontal = () => <div className="w-2 h-px bg-gray-900 mx-2" />;
